module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.c68a0a65.svg";